export default "__VITE_ASSET__DbDPCDxx__"